import React, { useEffect, useState } from "react";
import { useFloatingWindows } from "@/lib/floatingWindows";
import { byStatus, finApi, isArchived } from "@/lib/financeApi";
import { field } from "@/components/nds/windows/finance/parts";
import PaycheckForm from "@/components/nds/windows/finance/PaycheckForm";

/** Staff "Log paycheck" in its own window; saving closes it and refreshes any paycheck card listening. */
export default function PaycheckFormWindow({ win }) {
  const { closeWindow } = useFloatingWindows();
  const [rid, setRid] = useState(win.payload?.residentId || "");
  const [residents, setResidents] = useState(null);
  useEffect(() => {
    if (!win.payload?.residentId) finApi.get("/residents", { status: "all" }).then((d) => setResidents(byStatus(d.residents || d.items || []))).catch(() => setResidents([]));
  }, [win.payload?.residentId]);
  const done = () => {
    window.dispatchEvent(new CustomEvent("fin:paycheck-logged"));
    if (win.id === "tab-main") { window.close(); return; }
    closeWindow(win.id);
  };
  return (
    <div className="p-4 space-y-3">
      {!win.payload?.residentId && (
        <select value={rid} onChange={(e) => setRid(e.target.value)} data-testid="fin-paycheck-form-resident" className={`${field} w-full`}>
          <option value="">{residents ? "Choose a resident…" : "Loading residents…"}</option>
          {[["Current residents", false], ["Archived residents (last check)", true]].map(([label, arch]) => (
            <optgroup key={label} label={label}>{(residents || []).filter((r) => isArchived(r) === arch)
              .map((r) => <option key={r.id} value={r.id}>{r.first_name} {r.last_name}{arch ? " (Archived)" : ""}</option>)}</optgroup>))}
        </select>
      )}
      {rid && <PaycheckForm key={rid} residentId={rid} onDone={done} onCancel={() => closeWindow(win.id)} />}
    </div>
  );
}
